import getItem from '../services/getItem';
import checkIfResponseSuccess from '../services/utils/checkIfResponseSuccess';
import TailoredXpData from '../store/schema/TailoredXpData';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import Message from 'owa-service/lib/contract/Message';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';

function getTailoredXpDataResponseShape(): ItemResponseShape {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: [
            propertyUri({ FieldURI: 'TailoredXpEntities' }),
            propertyUri({ FieldURI: 'TailoredXpCalendarEventIds' }),
            propertyUri({ FieldURI: 'TailoredXpEntitiesStatus' }),
            propertyUri({ FieldURI: 'EntityNamesMap' }),
        ],
    });
}

function processResponseMessage(responseMessage: SingleResponseMessage[]): TailoredXpData {
    if (checkIfResponseSuccess(responseMessage[0])) {
        const itemInfoResponseMessage = responseMessage[0] as ItemInfoResponseMessage;
        const responseItem = itemInfoResponseMessage.Items[0];
        const {
            TailoredXpEntities,
            TailoredXpCalendarEventIds,
            TailoredXpEntitiesStatus,
            EntityNamesMap,
        } = responseItem as Message;
        return <TailoredXpData>{
            TailoredXpEntities: TailoredXpEntities,
            TailoredXpCalendarEventIds: TailoredXpCalendarEventIds,
            TailoredXpEntitiesStatus: TailoredXpEntitiesStatus,
            EntityNamesMap: EntityNamesMap,
        };
    }
    return <TailoredXpData>{};
}

export default function loadTailoredXpData(itemId: string): Promise<TailoredXpData> {
    return getItem(
        [itemId],
        getTailoredXpDataResponseShape(),
        'ItemTailoredXpData',
        'Exchange2013'
    ).then(responseMessage => {
        return processResponseMessage(responseMessage);
    });
}
